export default "__VITE_ASSET__DqabkBKl__"